import { createReducer } from 'redux-create-reducer';
import createActionCreator from './createActionCreator';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import isEmpty from 'lodash/isEmpty';
import forOwn from 'lodash/forOwn';
import merge from 'lodash/merge';
import extend from 'lodash/extend';
import traverse from 'json-schema-traverse';
import { jsonFormSchema } from '../resource/formSchema';
import { authHeader } from '../services/authHeaderService';
import {ApplicationInsights} from '@microsoft/applicationinsights-web'
import {configuration} from "../configuration";
import { handleSpouseChange, removeSpouseIfApplicable, updateSpouse, isNonActiveContactStatus } from '../util/spouseUtil';
import recordTypes from '../resource/recordTypes.json'

const SET_FORMS = 'SET_FORMS';
const SET_FORM_DATA = 'SET_FORM_DATA';
const SET_FINANCIAL_ACCOUNTS = 'SET_FINANCIAL_ACCOUNTS';
const SET_JOINT_FINANCIAL_ACCOUNTS = 'SET_JOINT_FINANCIAL_ACCOUNTS';
const SET_ACTIVE_FORM = 'SET_ACTIVE_FORM';
const UPDATE_CONTACT = 'UPDATE_CONTACT';
const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
const UPDATE_FINANCIAL_ACCOUNT = 'UPDATE_FINANCIAL_ACCOUNT';
const UPDATE_AWD_PAC = 'UPDATE_AWD_PAC';
const ADD_FINANCIAL_ACCOUNT = 'ADD_FINANCIAL_ACCOUNT';
const UPDATE_BENEFICIARY = 'UPDATE_BENEFICIARY';
const UPDATE_SPOUSAL_CONTACT_CONTACT_RELATION = 'UPDATE_SPOUSAL_CONTACT_CONTACT_RELATION';
const UPDATE_RMA = 'UPDATE_RMA';
const UPDATE_NRMA = 'UPDATE_NRMA';
const UPDATE_RNMA = 'UPDATE_RNMA';
const UPDATE_NRNMA = 'UPDATE_NRNMA';
const UPDATE_AAC = 'UPDATE_AAC';
const UPDATE_AAE = 'UPDATE_AAE';
const UPDATE_AAFI = 'UPDATE_AAFI';
const UPDATE_AAAM = 'UPDATE_AAAM';
const UPDATE_AACNM = 'UPDATE_AACNM';
const UPDATE_AAFINM = 'UPDATE_AAFINM';
const UPDATE_AAENM = 'UPDATE_AAENM';
const UPDATE_AAANM = 'UPDATE_AAANM';
const UPDATE_OTHER_ASSETS = 'UPDATE_OTHER_ASSETS';
const UPDATE_FIXED_ASSETS = 'UPDATE_FIXED_ASSETS';
const UPDATE_LIABILITIES = 'UPDATE_LIABILITIES';
const ADD_BENEFICIARY = 'ADD_BENEFICIARY';
const ADD_AWD_PAC = 'ADD_AWD_PAC';
export const SUBMITTING_FORMS = 'SUBMITTING_FORMS';
const UPDATE_SPOUSE = 'UPDATE_SPOUSE';
const UPDATE_THIRD_PARTY_INFORMATION = 'UPDATE_THIRD_PARTY_INFORMATION';
const UPDATE_CONSENT_CONTACT = 'UPDATE_CONSENT_CONTACT';
const UPDATE_POA_CONTACT = 'UPDATE_POA_CONTACT';
const UPDATE_POA_ACCOUNT = 'UPDATE_POA_ACCOUNT';
const UPDATE_VERIFIED = 'UPDATE_VERIFIED';
const SET_NET_WORTH = 'SET_NET_WORTH';

const initialState = {
    forms: [],
    submitting: "initiated",
    financialAccounts: [],
    jointFinancialAccounts: [],
    portfolioCodes: [],
    jointPortfolioCodes: null,
    Account: {},
    Contact: {},
    FinServ__FinancialAccount__c: [],
    Beneficiary__c: [],
    AWD_PACs__c: [],
    Spouse: {},
    RegisteredMawerAsset: {},
    RegisteredNonMawerAsset: {},
    NonRegisteredMawerAsset: {},
    NonRegisteredNonMawerAsset: {},
    SpousalContactContactRelation: {},
    AssetAllocationCash: {},
    AssetAllocationEquity: {},
    AssetAllocationFixedIncome: {},
    AssetAllocationAlternativeMawer: {},
    AssetAllocationCashNonMawer: {},
    AssetAllocationFixedIncomeNonMawer: {},
    AssetAllocationEquityNonMawer: {},
    AssetAllocationAlternativeNonMawer: {},
    FixedAssets: {},
    OtherAssets: {},
    Liabilities: {},
    ThirdPartyInformation: {},
    ConsentContact: {},
    PoaContact: {},
    PoaAccount: {},
    verified: false,
    netWorth: 0
};

const beneficiaryWithContactTypes = [
    "Successor Holder",
    "Successor Annuitant",
    "Beneficiary",
    "Contingent Beneficiary"
];

const beneficiaryWithoutContactTypes = [
    "Charity",
    "Estate"
];

let recordType = {};
let initialData = {};

const createAssetAllocationDefault = (contactAccountId, assetsRecordTypeId, type, source, name) => ({
    properties: {
        FinServ__PrimaryOwner__c: contactAccountId,
        FinServ__AssetsAndLiabilitiesSource__c: source,
        FinServ__AssetsAndLiabilitiesType__c: type,
        RecordTypeId: assetsRecordTypeId,
        Name: name
    }
});

const createAssetDefault = (contactAccountId, assetsRecordTypeId, type, name) => ({
    properties: {
        FinServ__PrimaryOwner__c: contactAccountId,
        FinServ__AssetsAndLiabilitiesType__c: type,
        RecordTypeId: assetsRecordTypeId,
        Name: name
    }
});

const hasAssetLiabilityUserData = (asset) => {
    if (isEmpty(asset)) {
        return false;
    }

    return (asset.FinServ__Amount__c != null && asset.FinServ__Amount__c !== '')
        || (asset.Asset_Percentage__c != null && asset.Asset_Percentage__c !== '')
        || !isEmpty(asset.FinServ__Description__c);
};

const pushAssetLiabilityRequest = (sfCompositeRequest, asset, initialAsset, referenceId, ownerId) => {
    let request = {};
    const initialProps = initialAsset && initialAsset.properties ? initialAsset.properties : {};

    if (!isEmpty(asset.Id) && asset) {
        const assetId = asset.Id;
        const assetBody = { ...asset };
        delete assetBody.Id;

        const hasChanges = Object.keys(assetBody).some((key) => assetBody[key] !== initialProps[key]);
        if (hasChanges) {
            request = {
                "method": "PATCH",
                "url": "/services/data/v42.0/sobjects/FinServ__AssetsAndLiabilities__c/" + assetId,
                "referenceId": referenceId,
                "body": assetBody
            };
        }
    } else if (hasAssetLiabilityUserData(asset)) {
        request = {
            "method": "POST",
            "url": "/services/data/v42.0/sobjects/FinServ__AssetsAndLiabilities__c",
            "referenceId": referenceId,
            "body": {
                ...asset,
                "OwnerId": ownerId
            }
        };
    }

    if (!isEmpty(request)) {
        sfCompositeRequest.compositeRequest.push(request);
    }
};

export const flatten = (obj) => {
    let flat = {};

    for (var key in obj) {
        if (isObject(obj[key]) && !isArray(obj[key])) {
            flat = { ...flat, ...flatten(obj[key]) };
        } else if (isArray(obj[key])) {
            flat[key] = obj[key].map((val) => flatten(val))
        } else {
            flat[key] = obj[key]
        }
    }

    return flat;
}

const setObjectTreeValue = (obj, path, value) => {
    let attribute = path.shift();

    if (path.length !== 0) {
        if (!obj[attribute]) {
            obj[attribute] = {};
        }

        setObjectTreeValue(obj[attribute], path, value);
    } else {
        obj[attribute] = value;
    }
}

export const expand = (obj, delimiter = '-', validator = null) => {
    let expanded = {};

    for (var key in obj) {
        let path = key.split(delimiter);
        if (typeof validator === 'function') {
            path = path.reduce((acc, value) => {
                if (validator(value)) {
                    acc.push(value);
                }

                return acc;
            }, [])
        }

        setObjectTreeValue(expanded, path, obj[key]);
    }

    return expanded;
}

export const flattenConcatenateKeys = (obj, delimiter = '-', validator = null) => {
    let flat = {};

    if (isObject(obj)) {
        for (var key in obj) {
            if (!obj.hasOwnProperty(key)) continue;

            if (isObject(obj[key]) && !isArray(obj[key])) {
                var flatObject = flattenConcatenateKeys(obj[key], delimiter, validator);

                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;

                    if (typeof validator === 'function') {
                        if (validator(key)) {
                            flat[key + delimiter + x] = flatObject[x];
                        } else {
                            flat[x] = flatObject[x];
                        }
                    } else {
                        flat[key + delimiter + x] = flatObject[x];
                    }
                }
            } else if (isArray(obj[key])) {
                flat[key] = obj[key].map(val => flattenConcatenateKeys(val, delimiter, validator))
            } else {
                flat[key] = obj[key];
            }
        }
    } else {
        flat = obj;
    }

    return flat;
}

export const mapFormDataToFormSchema = (formData, formSchema) => {
    let mappedFormData = {};

    const getPath = (stringPath) => {
        let sanitizedPath = stringPath
            .replace(new RegExp(/[0-9]+\/properties/g), '')
            .replace(/properties/g, '')
            .replace(/\/([a-zA-Z]*?)\/oneOf/g, '');

        let path = sanitizedPath.split("/");

        return path.reduce((clean, value) => {
            if (
                value &&
                value !== 'dependencies'
            ) {
                clean.push(value);
            }

            return clean;
        }, [])
    }

    let cb = (schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) => {
        if (formData[keyIndex] !== undefined && formData[keyIndex] !== null) {
            let path = getPath(jsonPtr);
            setObjectTreeValue(mappedFormData, path, formData[keyIndex])
        }
    };

    traverse(formSchema, { cb });

    return mappedFormData;
}

const mapPortfolioFormDataToFormSchema = (portfolioForms, portfolios, portfolioBeneficiary, formData, dispatch) => {
    initialData.Beneficiary__c = [];
    return portfolioForms.reduce((formList, portfolio) => {
        Array.prototype.push.apply(formList, portfolio.Forms.reduce((availableForms, form) => {
            if (form.schema) {
                form.id = form.id + "-" + portfolio.FinServ__FinancialAccount__c.sfId;
                let portfolioRecord = portfolios.find(val => val.Id === portfolio.FinServ__FinancialAccount__c.sfId);
                let portfolioBeneficiaryToFind = portfolioBeneficiary.find(val => val.FinServ__FinancialAccount__c.sfId === portfolio.FinServ__FinancialAccount__c.sfId);
                let beneficiaryRecord = [];
                if (portfolioBeneficiaryToFind && portfolioBeneficiaryToFind.Beneficiaries && portfolioBeneficiaryToFind.Beneficiaries.length > 0) {
                    var beneficiaryArray = portfolioBeneficiaryToFind.Beneficiaries;
                    beneficiaryRecord = beneficiaryArray.reduce((beneficiaryList, beneficiary) => {
                        if (beneficiary.properties) {
                            delete beneficiary.properties.attributes;
                            let recordTypeText;
                            initialData.recordType.forEach(x => {
                                if (x.SobjectType === "Beneficiary__c" && x.Id === beneficiary.properties.RecordTypeId) {
                                    recordTypeText = x.Name;
                                }
                            })
                            beneficiary.properties.RecordType = recordTypeText;
                            beneficiaryList.push(beneficiary.properties);
                        }
                        return beneficiaryList;
                    }, []);
                }
                
                let noBeneficiaryElection = false;
                if (beneficiaryRecord.length > 0) {
                    beneficiaryRecord.forEach((x) => {
                        // Hard coding No election type
                        if (x.RecordTypeId === recordType.find(a => a.Name === 'No Election' && a.SobjectType === "Beneficiary__c").Id) {
                            noBeneficiaryElection = true;
                        }
                    });
                }
                let beneficiaryObjectToAdd = {
                    id: form.id,
                    beneficiaries: beneficiaryRecord
                }
                dispatch(actionCreators.addBeneficiary(beneficiaryObjectToAdd));
                portfolioRecord.No_Beneficiary_Election = noBeneficiaryElection;
                let portfolioFormData = mapFormDataToFormSchema(
                    { ...formData, ...flattenConcatenateKeys({ FinServ__FinancialAccount__c: portfolioRecord }), Beneficiary__c: beneficiaryRecord },
                    form.schema
                );

                form.data = portfolioFormData;
                dispatch(actionCreators.addFinancialAccount(portfolioRecord));
                availableForms.push(form);
            }

            return availableForms;
        }, []));

        return formList;
    }, [])
}

const updateFinAccouts = (finAcctList, Account, finAcctsToUpdate) => {
    finAcctList.forEach(finAcct => {
        const isLeveraged = !isEmpty(Account["LeveragedDisclosureAccounts"]) && !isEmpty(Account["LeveragedDisclosureAccounts"].find(portCode => portCode === finAcct.PortfolioCode));
        const isCollateral = !isEmpty(Account["CollateralAccounts"]) &&  !isEmpty(Account["CollateralAccounts"].find(portCode => portCode === finAcct.PortfolioCode));
        let finAcctNeedsUpdate = false;

        if (isLeveraged != finAcct.LeveragedAccount) {
            finAcctNeedsUpdate = true;
            finAcct.LeveragedAccount = isLeveraged;
        }

        if (isCollateral != finAcct.CollateralAccount) {
            finAcctNeedsUpdate = true;
            finAcct.CollateralAccount = isCollateral;
        }
        
        if(finAcctNeedsUpdate) {
            finAcctsToUpdate.push({
                Id: finAcct.Id, 
                Leveraged_Account__c: finAcct.LeveragedAccount, 
                Collateral_Account__c: finAcct.CollateralAccount 
            });
        }
    });
}

export const actionCreators = {
    getForms: (params) => async (dispatch) => {
        let forms = [];
        let path = params["0"];
        const transactionUrl = `api/${path}/${params["id"]}`;
        const requestOptions = {
            method: 'GET',
            headers: authHeader()
        };
        const response = await fetch(transactionUrl, requestOptions);

        if (!response.ok) {
            throw new Error(`Failed to load transaction (${response.status} ${response.statusText}) from ${transactionUrl}`);
        }

        // It was const before, I have to change it for all asset classes though it will be bad practice at the moment
        initialData = await response.json();
        // const recordTypeUrl = `/api/value/recordType`;
        // const recordTypeResponse = await fetch(recordTypeUrl, requestOptions);
        recordType = recordTypes;
        initialData.recordType = recordType;

        let { properties, Contact, Account, financialAccounts, jointFinancialAccounts, Spouse = { properties: {} }, SpousalContactContactRelation = {}, AWD_PACs__c,
            RegisteredMawerAsset, NonRegisteredMawerAsset, RegisteredNonMawerAsset, NonRegisteredNonMawerAsset,
            AssetAllocationCash, AssetAllocationEquity, AssetAllocationFixedIncome, AssetAllocationAlternativeMawer,
            AssetAllocationCashNonMawer, AssetAllocationFixedIncomeNonMawer, AssetAllocationEquityNonMawer, AssetAllocationAlternativeNonMawer,
            FixedAssets, OtherAssets, Liabilities, PoaContact = { properties: {} }, PoaAccount = { properties: {} } } = initialData;
            if (!isEmpty(Contact.properties.Citizenship__c)) {
                Contact.properties.Citizenship__c = Contact.properties.Citizenship__c.split(';');
            }
        
        if (isEmpty(Contact.properties.FinServ__MaritalStatus__c)) {
            Contact.properties.FinServ__MaritalStatus__c = "";
        }
        
        if (!isEmpty(Account.properties.ShippingStreet)
            || !isEmpty(Account.properties.ShippingCity)
            || !isEmpty(Account.properties.ShippingState)
            || !isEmpty(Account.properties.ShippingCountry)
            || !isEmpty(Account.properties.ShippingPostalCode)) {
            Account.properties.Is_Mailing_Address_Different__c = true;
        }
        
        const assetsRecordTypeId = recordType.find(a => a.Name === "Asset" && a.SobjectType === "FinServ__AssetsAndLiabilities__c").Id;
        const liabilitiesRecordTypeId = recordType.find(a => a.Name === "Liability" && a.SobjectType === "FinServ__AssetsAndLiabilities__c").Id;
        if (FixedAssets == null || isEmpty(FixedAssets.properties)) {
            FixedAssets = {
                properties: {
                    FinServ__PrimaryOwner__c: Contact.properties.AccountId,
                    FinServ__AssetsAndLiabilitiesType__c: "Fixed Assets",
                    RecordTypeId: assetsRecordTypeId,
                    Name: "Fixed Assets"
                }
            }
        }
        
        if (Liabilities == null || isEmpty(Liabilities.properties)) {
            Liabilities = {
                properties: {
                    FinServ__PrimaryOwner__c: Contact.properties.AccountId,
                    FinServ__AssetsAndLiabilitiesType__c: "Liabilities",
                    RecordTypeId: liabilitiesRecordTypeId,
                    Name: "Liabilities"
                }
            }
        }
        
        if (AssetAllocationCash == null || isEmpty(AssetAllocationCash.properties)) {
            AssetAllocationCash = {
                properties: {
                    FinServ__PrimaryOwner__c: Contact.properties.AccountId,
                    FinServ__AssetsAndLiabilitiesSource__c: "At Mawer",
                    FinServ__AssetsAndLiabilitiesType__c: "Cash",
                    RecordTypeId: assetsRecordTypeId,
                    Name: "Asset Allocation - Cash"
                }
            }
        }
        
        if (AssetAllocationEquity == null || isEmpty(AssetAllocationEquity.properties)) {
            AssetAllocationEquity = {
                properties: {
                    FinServ__PrimaryOwner__c: Contact.properties.AccountId,
                    FinServ__AssetsAndLiabilitiesSource__c: "At Mawer",
                    FinServ__AssetsAndLiabilitiesType__c: "Equity",
                    RecordTypeId: assetsRecordTypeId,
                    Name: "Asset Allocation - Equity"
                }
            }
        }
        
        if (AssetAllocationFixedIncome== null || isEmpty(AssetAllocationFixedIncome.properties)) {
            AssetAllocationFixedIncome = createAssetAllocationDefault(Contact.properties.AccountId, assetsRecordTypeId, "Fixed Income", "At Mawer", "Asset Allocation - Fixed Income");
        }

        if (AssetAllocationAlternativeMawer == null || isEmpty(AssetAllocationAlternativeMawer.properties)) {
            AssetAllocationAlternativeMawer = createAssetAllocationDefault(Contact.properties.AccountId, assetsRecordTypeId, "Alternative Investments", "At Mawer", "Asset Allocation - Alternative Investments");
        }

        if (AssetAllocationCashNonMawer == null || isEmpty(AssetAllocationCashNonMawer.properties)) {
            AssetAllocationCashNonMawer = createAssetAllocationDefault(Contact.properties.AccountId, assetsRecordTypeId, "Cash", "Outside Mawer", "Asset Allocation - Cash Outside Mawer");
        }

        if (AssetAllocationFixedIncomeNonMawer == null || isEmpty(AssetAllocationFixedIncomeNonMawer.properties)) {
            AssetAllocationFixedIncomeNonMawer = createAssetAllocationDefault(Contact.properties.AccountId, assetsRecordTypeId, "Fixed Income", "Outside Mawer", "Asset Allocation - Fixed Income Outside Mawer");
        }

        if (AssetAllocationEquityNonMawer == null || isEmpty(AssetAllocationEquityNonMawer.properties)) {
            AssetAllocationEquityNonMawer = createAssetAllocationDefault(Contact.properties.AccountId, assetsRecordTypeId, "Equity", "Outside Mawer", "Asset Allocation - Equity Outside Mawer");
        }

        if (AssetAllocationAlternativeNonMawer == null || isEmpty(AssetAllocationAlternativeNonMawer.properties)) {
            AssetAllocationAlternativeNonMawer = createAssetAllocationDefault(Contact.properties.AccountId, assetsRecordTypeId, "Alternative Investments", "Outside Mawer", "Asset Allocation - Alternative Investments Outside Mawer");
        }

        if (OtherAssets == null || isEmpty(OtherAssets.properties)) {
            OtherAssets = createAssetDefault(Contact.properties.AccountId, assetsRecordTypeId, "Other", "Other Assets");
        }

        if (RegisteredMawerAsset == null || isEmpty(RegisteredMawerAsset.properties)) {
            RegisteredMawerAsset = {
                properties: {
                    FinServ__PrimaryOwner__c: Contact.properties.AccountId,
                    FinServ__AssetsAndLiabilitiesSource__c: "At Mawer",
                    FinServ__AssetsAndLiabilitiesType__c: "Registered Financial Assets",
                    RecordTypeId: assetsRecordTypeId,
                    Name: "RegisteredMawerAsset"
                }
            }
        }
        
        if (RegisteredNonMawerAsset == null || isEmpty(RegisteredNonMawerAsset.properties)) {
            RegisteredNonMawerAsset = {
                properties: {
                    FinServ__PrimaryOwner__c: Contact.properties.AccountId,
                    FinServ__AssetsAndLiabilitiesSource__c: "Outside Mawer",
                    FinServ__AssetsAndLiabilitiesType__c: "Registered Financial Assets",
                    RecordTypeId: assetsRecordTypeId,
                    Name: "RegisteredNonMawerAsset"
                }
            }
        }
        
        if (NonRegisteredMawerAsset == null || isEmpty(NonRegisteredMawerAsset.properties)) {
            NonRegisteredMawerAsset = {
                properties: {
                    FinServ__PrimaryOwner__c: Contact.properties.AccountId,
                    FinServ__AssetsAndLiabilitiesSource__c: "At Mawer",
                    FinServ__AssetsAndLiabilitiesType__c: "Non-Registered Financial Assets",
                    RecordTypeId: assetsRecordTypeId,
                    Name: "NonRegisteredMawerAsset"
                }
            }
        }
        
        if (NonRegisteredNonMawerAsset == null || isEmpty(NonRegisteredNonMawerAsset.properties)) {
            NonRegisteredNonMawerAsset = {
                properties: {
                    FinServ__PrimaryOwner__c: Contact.properties.AccountId,
                    FinServ__AssetsAndLiabilitiesSource__c: "Outside Mawer",
                    FinServ__AssetsAndLiabilitiesType__c: "Non-Registered Financial Assets",
                    RecordTypeId: assetsRecordTypeId,
                    Name: "NonRegisteredNonMawerAsset"
                }
            }
        }

        const spouseProperties = !isEmpty(Spouse)
            && !isNonActiveContactStatus(Spouse.properties && Spouse.properties.Status__c)
            ? Spouse.properties
            : [];

        let formData = {
            ...flattenConcatenateKeys({ Contact: Contact.properties }),
            ...flattenConcatenateKeys({ Account: Account.properties }),
            ...flattenConcatenateKeys({ Spouse: spouseProperties }),
            ...flattenConcatenateKeys({ RegisteredMawerAsset: RegisteredMawerAsset.properties }),
            ...flattenConcatenateKeys({ NonRegisteredMawerAsset: NonRegisteredMawerAsset.properties }),
            ...flattenConcatenateKeys({ RegisteredNonMawerAsset: RegisteredNonMawerAsset.properties }),
            ...flattenConcatenateKeys({ NonRegisteredNonMawerAsset: NonRegisteredNonMawerAsset.properties }),
            ...flattenConcatenateKeys({ AssetAllocationCash: AssetAllocationCash.properties }),
            ...flattenConcatenateKeys({ AssetAllocationEquity: AssetAllocationEquity.properties }),
            ...flattenConcatenateKeys({ AssetAllocationFixedIncome: AssetAllocationFixedIncome.properties }),
            ...flattenConcatenateKeys({ AssetAllocationAlternativeMawer: AssetAllocationAlternativeMawer.properties }),
            ...flattenConcatenateKeys({ AssetAllocationCashNonMawer: AssetAllocationCashNonMawer.properties }),
            ...flattenConcatenateKeys({ AssetAllocationFixedIncomeNonMawer: AssetAllocationFixedIncomeNonMawer.properties }),
            ...flattenConcatenateKeys({ AssetAllocationEquityNonMawer: AssetAllocationEquityNonMawer.properties }),
            ...flattenConcatenateKeys({ AssetAllocationAlternativeNonMawer: AssetAllocationAlternativeNonMawer.properties }),
            ...flattenConcatenateKeys({ FixedAssets: FixedAssets.properties }),
            ...flattenConcatenateKeys({ OtherAssets: OtherAssets.properties }),
            ...flattenConcatenateKeys({ Liabilities: Liabilities.properties }),
            ...flattenConcatenateKeys({ PoaContact: PoaContact.properties }),
            ...flattenConcatenateKeys({ PoaAccount: PoaAccount.properties }),
            ...flattenConcatenateKeys({ SpousalContactContactRelation: !isEmpty(SpousalContactContactRelation) ? SpousalContactContactRelation : []}),
            AWD_PACs__c: AWD_PACs__c,
            financialAccounts,
            jointFinancialAccounts
        }

        if (properties.IncludeKYC) {
            jsonFormSchema.forEach(x => {
                if (x.id === "KYC") {
                    forms.push(x);
                }
            })
        }
        
        dispatch(actionCreators.updateAccount(Account.properties));
        dispatch(actionCreators.updateContact(Contact.properties));
        if (!isEmpty(Spouse) && !isNonActiveContactStatus(Spouse.properties && Spouse.properties.Status__c)) {
            dispatch(actionCreators.updateSpouse(Spouse.properties));
            dispatch(actionCreators.updateSpousalContactContactRelation(SpousalContactContactRelation))
        }
        dispatch(actionCreators.updateRma(RegisteredMawerAsset.properties));
        dispatch(actionCreators.updateNrma(NonRegisteredMawerAsset.properties));
        dispatch(actionCreators.updateRnma(RegisteredNonMawerAsset.properties));
        dispatch(actionCreators.updateNrnma(NonRegisteredNonMawerAsset.properties));
        dispatch(actionCreators.updateAac(AssetAllocationCash.properties));
        dispatch(actionCreators.updateAae(AssetAllocationEquity.properties));
        dispatch(actionCreators.updateAafi(AssetAllocationFixedIncome.properties));
        dispatch(actionCreators.updateAaam(AssetAllocationAlternativeMawer.properties));
        dispatch(actionCreators.updateAacnm(AssetAllocationCashNonMawer.properties));
        dispatch(actionCreators.updateAafinm(AssetAllocationFixedIncomeNonMawer.properties));
        dispatch(actionCreators.updateAaenm(AssetAllocationEquityNonMawer.properties));
        dispatch(actionCreators.updateAaanm(AssetAllocationAlternativeNonMawer.properties));
        dispatch(actionCreators.updateFixedAssets(FixedAssets.properties));
        dispatch(actionCreators.updateOtherAssets(OtherAssets.properties));
        dispatch(actionCreators.updateLiabilities(Liabilities.properties));
        dispatch(actionCreators.updateThirdPartyInformation({}));
        dispatch(actionCreators.updateConsentContact({}));
        dispatch(actionCreators.updatePoaContact(PoaContact.properties));
        dispatch(actionCreators.updatePoaAccount(PoaAccount.properties));

        // for(var AWD of AWD_PACs__c ) {
        //     dispatch(actionCreators.addAwdPac(AWD));
        // }
        
        // properties.PortfolioForms.forEach(x => {
        //     if (x.Forms.length > 0) {
        //         for (var index in x.Forms) {
        //             var matchedSchema = jsonFormSchema.find(schema => schema.name === x.Forms[index].Name);
        //             if (matchedSchema !== null && matchedSchema !== undefined) {
        //                 x.Forms[index] = matchedSchema;
        //             }
        //         }
        //     }
        // });
        //
        // let portfolioForms = mapPortfolioFormDataToFormSchema(properties.PortfolioForms, properties.Portfolios, properties.PortfolioBeneficiaries, formData, dispatch);
        //
        // Array.prototype.push.apply(forms, portfolioForms);
        dispatch({ type: SET_FORMS, forms: forms });
        dispatch({ type: SET_FORM_DATA, formId: "KYC", formData });
        dispatch({ type: SET_FINANCIAL_ACCOUNTS, financialAccounts });
        dispatch({ type: SET_JOINT_FINANCIAL_ACCOUNTS, jointFinancialAccounts });
    },
    setFormData: (formId, formData) => (dispatch, getState) => {
        let expanded = expand(formData, '-', (attr) => attr.charAt(0) !== '_');
        let { Beneficiary__c, FinServ__FinancialAccount__c, Contact, Spouse, Account, AWD_PACs__c, RegisteredMawerAsset, NonRegisteredMawerAsset, RegisteredNonMawerAsset, NonRegisteredNonMawerAsset,
            AssetAllocationCash, AssetAllocationEquity, AssetAllocationFixedIncome, AssetAllocationAlternativeMawer,
            AssetAllocationCashNonMawer, AssetAllocationFixedIncomeNonMawer, AssetAllocationEquityNonMawer, AssetAllocationAlternativeNonMawer,
            FixedAssets, OtherAssets, Liabilities, ThirdPartyInformation, ConsentContact,
            PoaContact, PoaAccount, totalNetWorth } = expanded;
        const previousContactState = getState().transaction.Contact;

        if (typeof Contact === 'object') {
            for (const property in Contact) {
                if (Contact[property] === undefined) {
                    Contact[property] = '';
                }
            }
            dispatch(actionCreators.updateContact(Contact));
            removeSpouseIfApplicable(Contact, dispatch, previousContactState);
        }

        if (typeof Account === 'object') {
            dispatch(actionCreators.updateAccount(Account));
        }

        if (typeof FinServ__FinancialAccount__c === 'object') {
            dispatch(actionCreators.updateFinancialAccount(FinServ__FinancialAccount__c));
        }

        // if (typeof Beneficiary__c === 'object') {
        //     let beneficiaryToUpdate = {id: formId, beneficiaries: Beneficiary__c}
        //     dispatch(actionCreators.updateBeneficiary(beneficiaryToUpdate));
        // }
        //
        // if (typeof AWD_PACs__c === 'object') {
        //     dispatch(actionCreators.updateAwdPac(AWD_PACs__c));
        // }
        
        if (typeof RegisteredMawerAsset === 'object') {
            dispatch(actionCreators.updateRma(RegisteredMawerAsset));
        }
        
        if (typeof RegisteredNonMawerAsset === 'object') {
            dispatch(actionCreators.updateRnma(RegisteredNonMawerAsset));
        }
        
        if (typeof NonRegisteredMawerAsset === 'object') {
            dispatch(actionCreators.updateNrma(NonRegisteredMawerAsset));
        }
        
        if (typeof NonRegisteredNonMawerAsset === 'object') {
            dispatch(actionCreators.updateNrnma(NonRegisteredNonMawerAsset));
        }
        
        if (typeof AssetAllocationCash === 'object') {
            dispatch(actionCreators.updateAac(AssetAllocationCash));
        }
        
        if (typeof AssetAllocationEquity === 'object') {
            dispatch(actionCreators.updateAae(AssetAllocationEquity));
        }
        
        if (typeof AssetAllocationFixedIncome === 'object') {
            dispatch(actionCreators.updateAafi(AssetAllocationFixedIncome));
        }

        if (typeof AssetAllocationAlternativeMawer === 'object') {
            dispatch(actionCreators.updateAaam(AssetAllocationAlternativeMawer));
        }

        if (typeof AssetAllocationCashNonMawer === 'object') {
            dispatch(actionCreators.updateAacnm(AssetAllocationCashNonMawer));
        }

        if (typeof AssetAllocationFixedIncomeNonMawer === 'object') {
            dispatch(actionCreators.updateAafinm(AssetAllocationFixedIncomeNonMawer));
        }

        if (typeof AssetAllocationEquityNonMawer === 'object') {
            dispatch(actionCreators.updateAaenm(AssetAllocationEquityNonMawer));
        }

        if (typeof AssetAllocationAlternativeNonMawer === 'object') {
            dispatch(actionCreators.updateAaanm(AssetAllocationAlternativeNonMawer));
        }
        
        if (typeof Liabilities === 'object') {
            dispatch(actionCreators.updateLiabilities(Liabilities));
        }
        
        if (typeof FixedAssets === 'object') {
            dispatch(actionCreators.updateFixedAssets(FixedAssets));
        }

        if (typeof OtherAssets === 'object') {
            dispatch(actionCreators.updateOtherAssets(OtherAssets));
        }
        
        if (typeof ThirdPartyInformation === 'object') {
            dispatch(actionCreators.updateThirdPartyInformation(ThirdPartyInformation));
        }
        
        if (typeof ConsentContact === 'object') {
            dispatch(actionCreators.updateConsentContact(ConsentContact));
        }
        
        if (typeof PoaContact === 'object') {
            dispatch(actionCreators.updatePoaContact(PoaContact));
        }

        if (typeof PoaAccount === 'object') {
            dispatch(actionCreators.updatePoaAccount(PoaAccount));
        }

        if (totalNetWorth !== undefined && totalNetWorth !== null) {   
            dispatch({ type: SET_NET_WORTH, netWorth: totalNetWorth });
        }

        if (typeof Spouse === 'object') {
            handleSpouseChange({
                dispatch,
                getState,
                initialData,
                spouse: Spouse,
                previousContactState,
                recordType
            });
        }
        dispatch({ type: SET_FORM_DATA, formId, formData });
    },
    submitForms: (forms, transactionId, poaInformation) => async (dispatch, getState) => {
        const transaction = getState().transaction;
        const formData = transaction.forms.map(form => form.data);

        let expanded = formData.map(data => expand(data, '-', (attr) => attr.charAt(0) !== '_'));
        let data = merge.apply(null, expanded);

        let cleanData = {};
        forOwn(data, (value, key) => {
            if (value !== undefined) {
                cleanData[key] = value;
            }
        })
        
        if (cleanData.Contact && cleanData.Contact.Citizenship__c) {
            cleanData.Contact.Citizenship__c = cleanData.Contact.Citizenship__c.join(';');
        }

        let { Contact, Account, Spouse, RegisteredMawerAsset,
             NonRegisteredMawerAsset, RegisteredNonMawerAsset, NonRegisteredNonMawerAsset, AssetAllocationCash, AssetAllocationEquity, AssetAllocationFixedIncome,
             AssetAllocationAlternativeMawer, AssetAllocationCashNonMawer, AssetAllocationFixedIncomeNonMawer, AssetAllocationEquityNonMawer, AssetAllocationAlternativeNonMawer,
             FixedAssets, OtherAssets, Liabilities, ThirdPartyInformation, ConsentContact, PoaContact, PoaAccount } = cleanData;

        let { FinServ__ReciprocalRole__c } = initialData;
        let clientCache = {};
        if (!isEmpty(ThirdPartyInformation)) {
            clientCache.ThirdPartyInformation = ThirdPartyInformation;
        }
        
        if (!isEmpty(ConsentContact)) {
            clientCache.ConsentContact = ConsentContact;
        }
        
        if (!isEmpty(PoaContact)) {
            clientCache.PoaContact = PoaContact;
        }

        if (!isEmpty(PoaAccount)) {
            clientCache.PoaAccount = PoaAccount;
        }
        
        const tpiurl = `api/t/clientCaseCache/` + Account.Id;
    
        await fetch(tpiurl, {
            headers:{
                'Content-Type': 'application/json',
                'Authorization': authHeader().Authorization
            },
            method: 'POST',
            body: JSON.stringify(JSON.stringify(clientCache))
        })
        
        let sfCompositeRequest = {
            "allOrNone": true,
            "compositeRequest": []
        };

        if(!Account["Are_you_using_borrowed_money_to_invest__c"] || Account["Are_you_using_borrowed_money_to_invest__c"] === 'No') {
            Account["LeveragedDisclosureAccounts"] = null;
        }

        if (!isEmpty(Account["LeveragedDisclosureAccounts"])) {
            const leveragedAccountsList = [];

            Account["LeveragedDisclosureAccounts"].forEach((acct) => {
                leveragedAccountsList.push(acct.substring((acct.lastIndexOf(" ") +1)));
            });

            Account["LeveragedDisclosureAccounts"] = leveragedAccountsList;
        }

        if(!Account["Have_you_pledged_these_assets__c"] || Account["Have_you_pledged_these_assets__c"] === 'No') {
            Account["CollateralAccounts"] = null;
        }

        if (!isEmpty(Account["CollateralAccounts"])) {
            const collateralAccountsList = [];

            Account["CollateralAccounts"].forEach((acct) => {
                collateralAccountsList.push(acct.substring((acct.lastIndexOf(" ") +1)));
            });

            Account["CollateralAccounts"] = collateralAccountsList;
        }

        const finAcctsToUpdate = [];

        updateFinAccouts(transaction.financialAccounts, Account, finAcctsToUpdate);
        updateFinAccouts(transaction.jointFinancialAccounts, Account, finAcctsToUpdate);
        
        if (!isEmpty(finAcctsToUpdate)) {
            finAcctsToUpdate.forEach(finAcct => {
                const finAcctId = finAcct["Id"];
                delete finAcct["Id"];

                const financialAccountsRequest = {
                    "method": "PATCH",
                    "url": "/services/data/v42.0/sobjects/FinServ__FinancialAccount__c/" + finAcctId,
                    "referenceId" : "FinancialAccounts-" + finAcctId,
                    "body" : finAcct
                };

                sfCompositeRequest.compositeRequest.push(financialAccountsRequest);
            });
        }
       
        let accountId = Account.Id;
        delete Account.Id;
        delete Account.BillingAddress;
        delete Account.ShippingAddress;
        delete Account.LeveragedDisclosureAccounts;
        delete Account.CollateralAccounts;

        if (!Account.Is_Mailing_Address_Different__c) {
            Account.ShippingStreet = null;
            Account.ShippingCity = null;
            Account.ShippingState = null;
            Account.ShippingCountry = null;
            Account.ShippingPostalCode = null;
        }
        
        delete Account.Is_Mailing_Address_Different__c;
        
        if (Account["Tax_resident_other_than_Canada_or_US__c"] === "No") {
            Account["If_YES_please_list_country_name__c"] = null;
            Account["Other_Country_Taxpayer_ID_TIN__c"] = null;
        }

        if (Account["US_tax_resident_or_citizen__c"] === "No") {
            Account["US_Taxpayer_Identification_Number__c"] = null;
        }

        if (Account["Insider__c"] === "No") {
            Account["If_YES_to_Insider_list_company_name__c"] = null;
        }
        
        if (Account["Any_accounts_on_behalf_of_third_party__c"] === "No"){
            Account["Third_Party_Name__c"] = null;
            Account["Third_Party_City__c"] = null;
            Account["Third_Party_Country__c"] = null;
            Account["Third_Party_State__c"] = null;
            Account["Third_Party_Street__c"] = null;
            Account["Third_Party_Postal_Code__c"] = null;
            Account["Third_Party_Date_of_Birth__c"] = null;
            Account["Third_Party_Relationship_To_Client__c"] = null;
        }
        
        if (Account["Does_anyone_have_POA__c"] === "No"){
            Account["Is_POA_Signing__c"] = null;   
        }

        if (PoaContact != null && PoaContact["Insider__c"] === "No") {
            PoaContact["If_YES_to_Insider_list_company_name__c"] = null;
        }
        
        let accountRequest = {
                "method": "PATCH",
                "url": "/services/data/v42.0/sobjects/Account/" + accountId,
                "referenceId" : "ClientAccount",
                "body" : Account
        };
        sfCompositeRequest.compositeRequest.push(accountRequest);
        
        let contactId = Contact.Id;
        delete Contact.Id;
        delete Contact.Name;
        delete Contact.MailingAddress;
        
        if (isEmpty(Contact.Email)) {
            Contact.Email = "";
        }
        
        let contactRequest = {
                "method": "PATCH",
                "url": "/services/data/v42.0/sobjects/Contact/" + contactId,
                "referenceId" : "ClientContact",
                "body" : Contact
        };
        sfCompositeRequest.compositeRequest.push(contactRequest);

        // Add assets and liabilities request
        let registeredMawerAssetRequest = {};
        if (!isEmpty(RegisteredMawerAsset.Id) && RegisteredMawerAsset) {
            let registeredMawerAssetId = RegisteredMawerAsset.Id;
            delete RegisteredMawerAsset.Id;
            if (!RegisteredMawerAsset.hasOwnProperty('FinServ__Amount__c')) {
                registeredMawerAssetRequest = {
                    "method": "PATCH",
                    "url": "/services/data/v42.0/sobjects/FinServ__AssetsAndLiabilities__c/" + registeredMawerAssetId,
                    "referenceId" : "RegisteredMawerAsset",
                    "body" :  {
                        ...RegisteredMawerAsset,
                        "FinServ__Amount__c": null
                    }
                }
            } else if (initialData.RegisteredMawerAsset.properties.FinServ__Amount__c !== RegisteredMawerAsset.FinServ__Amount__c && RegisteredMawerAsset.hasOwnProperty('FinServ__Amount__c')) {
                registeredMawerAssetRequest = {
                    "method": "PATCH",
                    "url": "/services/data/v42.0/sobjects/FinServ__AssetsAndLiabilities__c/" + registeredMawerAssetId,
                    "referenceId" : "RegisteredMawerAsset",
                    "body" : RegisteredMawerAsset
                }
            }
        } else {
            registeredMawerAssetRequest = {
                "method": "POST",
                "url": "/services/data/v42.0/sobjects/FinServ__AssetsAndLiabilities__c",
                "referenceId": "RegisteredMawerAsset",
                "body": {
                    ...RegisteredMawerAsset,
                    "OwnerId": initialData.Account.properties.OwnerId
                }
            }
        }
        if (!isEmpty(registeredMawerAssetRequest)) {
            sfCompositeRequest.compositeRequest.push(registeredMawerAssetRequest);
        }

        let registeredNonMawerAssetRequest = {};
        if (!isEmpty(RegisteredNonMawerAsset.Id) && RegisteredNonMawerAsset) {
            let registeredNonMawerAssetId = RegisteredNonMawerAsset.Id;
            delete RegisteredNonMawerAsset.Id;
            if (!RegisteredNonMawerAsset.hasOwnProperty('FinServ__Amount__c')) {
                registeredNonMawerAssetRequest = {
                    "method": "PATCH",
                    "url": "/services/data/v42.0/sobjects/FinServ__AssetsAndLiabilities__c/" + registeredNonMawerAssetId,
                    "referenceId" : "RegisteredNonMawerAsset",
                    "body" :  {
                        ...RegisteredNonMawerAsset,
                        "FinServ__Amount__c": null
                    }
                }
            } else if (initialData.RegisteredNonMawerAsset.properties.FinServ__Amount__c !== RegisteredNonMawerAsset.FinServ__Amount__c && RegisteredNonMawerAsset.hasOwnProperty('FinServ__Amount__c')) {
                registeredNonMawerAssetRequest = {
                    "method": "PATCH",
                    "url": "/services/data/v42.0/sobjects/FinServ__AssetsAndLiabilities__c/" + registeredNonMawerAssetId,
                    "referenceId" : "RegisteredNonMawerAsset",
                    "body" : RegisteredNonMawerAsset
                }
            }
        } else {
            registeredNonMawerAssetRequest = {
                "method": "POST",
                "url": "/services/data/v42.0/sobjects/FinServ__AssetsAndLiabilities__c",
                "referenceId": "RegisteredNonMawerAsset",
                "body": {
                    ...RegisteredNonMawerAsset,
                    "OwnerId": initialData.Account.properties.OwnerId
                }
            }
        }
        if (!isEmpty(registeredNonMawerAssetRequest)) {
            sfCompositeRequest.compositeRequest.push(registeredNonMawerAssetRequest);
        }

        let nonRegisteredMawerAssetRequest = {};
        if (!isEmpty(NonRegisteredMawerAsset.Id) && NonRegisteredMawerAsset) {
            let nonRegisteredMawerAssetId = NonRegisteredMawerAsset.Id;
            delete NonRegisteredMawerAsset.Id;
            if (!NonRegisteredMawerAsset.hasOwnProperty('FinServ__Amount__c')) {
                nonRegisteredMawerAssetRequest = {
                    "method": "PATCH",
                    "url": "/services/data/v42.0/sobjects/FinServ__AssetsAndLiabilities__c/" + nonRegisteredMawerAssetId,
                    "referenceId" : "NonRegisteredMawerAsset",
                    "body" :  {
                        ...NonRegisteredMawerAsset,
                        "FinServ__Amount__c": null
                    }
                }
            } else if (initialData.NonRegisteredMawerAsset.properties.FinServ__Amount__c !== NonRegisteredMawerAsset.FinServ__Amount__c && NonRegisteredMawerAsset.hasOwnProperty('FinServ__Amount__c')) {
                nonRegisteredMawerAssetRequest = {
                    "method": "PATCH",
                    "url": "/services/data/v42.0/sobjects/FinServ__AssetsAndLiabilities__c/" + nonRegisteredMawerAssetId,
                    "referenceId" : "NonRegisteredMawerAsset",
                    "body" : NonRegisteredMawerAsset
                }
            }            
        } else {
            nonRegisteredMawerAssetRequest = {
                "method": "POST",
                "url": "/services/data/v42.0/sobjects/FinServ__AssetsAndLiabilities__c",
                "referenceId": "NonRegisteredMawerAsset",
                "body": {
                    ...NonRegisteredMawerAsset,
                    "OwnerId": initialData.Account.properties.OwnerId
                }
            }
        }
        if (!isEmpty(nonRegisteredMawerAssetRequest)) {
            sfCompositeRequest.compositeRequest.push(nonRegisteredMawerAssetRequest);
        }
                
        let nonRegisteredNonMawerAssetRequest = {};
        if (!isEmpty(NonRegisteredNonMawerAsset.Id) && NonRegisteredNonMawerAsset) {
            let nonRegisteredNonMawerAssetId = NonRegisteredNonMawerAsset.Id;
            delete NonRegisteredNonMawerAsset.Id;
            if (!NonRegisteredNonMawerAsset.hasOwnProperty('FinServ__Amount__c')) {
                nonRegisteredNonMawerAssetRequest = {
                    "method": "PATCH",
                    "url": "/services/data/v42.0/sobjects/FinServ__AssetsAndLiabilities__c/" + nonRegisteredNonMawerAssetId,
                    "referenceId" : "NonRegisteredNonMawerAsset",
                    "body" :  {
                        ...NonRegisteredNonMawerAsset,
                        "FinServ__Amount__c": null
                    }
                }
            } else if (initialData.NonRegisteredNonMawerAsset.properties.FinServ__Amount__c !== NonRegisteredNonMawerAsset.FinServ__Amount__c && NonRegisteredNonMawerAsset.hasOwnProperty('FinServ__Amount__c')) {
                nonRegisteredNonMawerAssetRequest = {
                    "method": "PATCH",
                    "url": "/services/data/v42.0/sobjects/FinServ__AssetsAndLiabilities__c/" + nonRegisteredNonMawerAssetId,
                    "referenceId" : "NonRegisteredNonMawerAsset",
                    "body" : NonRegisteredNonMawerAsset
                }
            }
        } else {
            nonRegisteredNonMawerAssetRequest = {
                "method": "POST",
                "url": "/services/data/v42.0/sobjects/FinServ__AssetsAndLiabilities__c",
                "referenceId": "NonRegisteredNonMawerAsset",
                "body": {
                    ...NonRegisteredNonMawerAsset,
                    "OwnerId": initialData.Account.properties.OwnerId
                }
            }
        }
        if (!isEmpty(nonRegisteredNonMawerAssetRequest)) {
            sfCompositeRequest.compositeRequest.push(nonRegisteredNonMawerAssetRequest);
        }
        
        // Add asset allocation requests
        let assetAllocationCashRequest = {};
        if (!isEmpty(AssetAllocationCash.Id) && AssetAllocationCash) {
            let assetAllocationCashId = AssetAllocationCash.Id;
            delete AssetAllocationCash.Id;
            if (initialData.AssetAllocationCash.properties.Asset_Percentage__c !== AssetAllocationCash.Asset_Percentage__c) {
                assetAllocationCashRequest = {
                    "method": "PATCH",
                    "url": "/services/data/v42.0/sobjects/FinServ__AssetsAndLiabilities__c/" + assetAllocationCashId,
                    "referenceId" : "AssetAllocationCash",
                    "body" : AssetAllocationCash
                }
            }
        } else {
            assetAllocationCashRequest = {
                "method": "POST",
                "url": "/services/data/v42.0/sobjects/FinServ__AssetsAndLiabilities__c",
                "referenceId": "AssetAllocationCash",
                "body": {
                    ...AssetAllocationCash,
                    "OwnerId": initialData.Account.properties.OwnerId
                }
            }
        }
        if (!isEmpty(assetAllocationCashRequest)) {
            sfCompositeRequest.compositeRequest.push(assetAllocationCashRequest);
        }
        
        let assetAllocationFixedIncomeRequest = {};
        if (!isEmpty(AssetAllocationFixedIncome.Id) && AssetAllocationFixedIncome) {
            let assetAllocationFixedIncomeId = AssetAllocationFixedIncome.Id;
            delete AssetAllocationFixedIncome.Id;
            if (initialData.AssetAllocationFixedIncome.properties.Asset_Percentage__c !== AssetAllocationFixedIncome.Asset_Percentage__c) {
                assetAllocationFixedIncomeRequest = {
                    "method": "PATCH",
                    "url": "/services/data/v42.0/sobjects/FinServ__AssetsAndLiabilities__c/" + assetAllocationFixedIncomeId,
                    "referenceId" : "AssetAllocationFixedIncome",
                    "body" : AssetAllocationFixedIncome
                }
            }
        } else {
            assetAllocationFixedIncomeRequest = {
                "method": "POST",
                "url": "/services/data/v42.0/sobjects/FinServ__AssetsAndLiabilities__c",
                "referenceId": "AssetAllocationFixedIncome",
                "body": {
                    ...AssetAllocationFixedIncome,
                    "OwnerId": initialData.Account.properties.OwnerId
                }
            }
        }
        if (!isEmpty(assetAllocationFixedIncomeRequest)) {
            sfCompositeRequest.compositeRequest.push(assetAllocationFixedIncomeRequest);
        }
        
        let assetAllocationEquityRequest = {};
        if (!isEmpty(AssetAllocationEquity.Id) && AssetAllocationEquity) {
            let assetAllocationEquityId = AssetAllocationEquity.Id;
            delete AssetAllocationEquity.Id;
            if (initialData.AssetAllocationEquity.properties.Asset_Percentage__c !== AssetAllocationEquity.Asset_Percentage__c) {
                assetAllocationEquityRequest = {
                    "method": "PATCH",
                    "url": "/services/data/v42.0/sobjects/FinServ__AssetsAndLiabilities__c/" + assetAllocationEquityId,
                    "referenceId" : "AssetAllocationEquity",
                    "body" : AssetAllocationEquity
                }
            }
        } else {
            assetAllocationEquityRequest = {
                "method": "POST",
                "url": "/services/data/v42.0/sobjects/FinServ__AssetsAndLiabilities__c",
                "referenceId": "AssetAllocationEquity",
                "body": {
                    ...AssetAllocationEquity,
                    "OwnerId": initialData.Account.properties.OwnerId
                }

            }
        }
        if (!isEmpty(assetAllocationEquityRequest)) {
            sfCompositeRequest.compositeRequest.push(assetAllocationEquityRequest);
        }

        pushAssetLiabilityRequest(sfCompositeRequest, AssetAllocationAlternativeMawer, initialData.AssetAllocationAlternativeMawer, "AssetAllocationAlternativeMawer", initialData.Account.properties.OwnerId);
        pushAssetLiabilityRequest(sfCompositeRequest, AssetAllocationCashNonMawer, initialData.AssetAllocationCashNonMawer, "AssetAllocationCashNonMawer", initialData.Account.properties.OwnerId);
        pushAssetLiabilityRequest(sfCompositeRequest, AssetAllocationFixedIncomeNonMawer, initialData.AssetAllocationFixedIncomeNonMawer, "AssetAllocationFixedIncomeNonMawer", initialData.Account.properties.OwnerId);
        pushAssetLiabilityRequest(sfCompositeRequest, AssetAllocationEquityNonMawer, initialData.AssetAllocationEquityNonMawer, "AssetAllocationEquityNonMawer", initialData.Account.properties.OwnerId);
        pushAssetLiabilityRequest(sfCompositeRequest, AssetAllocationAlternativeNonMawer, initialData.AssetAllocationAlternativeNonMawer, "AssetAllocationAlternativeNonMawer", initialData.Account.properties.OwnerId);
        pushAssetLiabilityRequest(sfCompositeRequest, OtherAssets, initialData.OtherAssets, "OtherAssets", initialData.Account.properties.OwnerId);
        pushAssetLiabilityRequest(sfCompositeRequest, FixedAssets, initialData.FixedAssets, "FixedAssets", initialData.Account.properties.OwnerId);
        pushAssetLiabilityRequest(sfCompositeRequest, Liabilities, initialData.Liabilities, "Liabilities", initialData.Account.properties.OwnerId);

        dispatch({ type: SUBMITTING_FORMS, submitting: "submitting" });
        if (!isEmpty(Spouse) && !isEmpty(getState().transaction.Spouse.Id)) {
            Spouse.Id = getState().transaction.Spouse.Id;
            await updateSpouse({
                contact: Contact,
                spouse: Spouse,
                account: Account,
                transactionId,
                initialData,
                recordType
            });
        }

        if (!isEmpty(ConsentContact)) {
            await updateConsentToShareInfoContact(ConsentContact, contactId, FinServ__ReciprocalRole__c, transactionId);
        }
        
        if (!isEmpty(PoaContact) && Account.Does_anyone_have_POA__c == "Yes") {
            await updatePoaContact(PoaContact, contactId, FinServ__ReciprocalRole__c, transactionId).then(async response => {
                await updatePoaAccount(PoaAccount, PoaContact, transactionId);
            });
        } else if (Account.Does_anyone_have_POA__c == "No" && poaInformation["PoaContact-Id"]){
            const tpiurl = `api/t${transactionId !== undefined ? `/${transactionId}` : ''}`;
            const poaId = poaInformation["PoaContact-Id"];

            const poaRelationshipCompositeRequest = {
                "allOrNone": true,
                "compositeRequest": [{
                    'method': 'GET',
                    'url': `/services/data/v42.0/query/?q=SELECT+Id,FinServ__Role__r.Name+FROM+FinServ__ContactContactRelation__c+WHERE+FinServ__Contact__c='${contactId}'+AND+FinServ__RelatedContact__c='${poaId}'+AND+FinServ__Role__r.Name='Power of Attorney'+AND+FinServ__Active__c=true`,
                    'referenceId': 'poaRelationship'
                }, {
                    'method': 'PATCH',
                    'url': `/services/data/v42.0/sobjects/FinServ__ContactContactRelation__c/@{poaRelationship.records[0].Id}`,
                    'referenceId': 'poaRelationshipDelete',
                    'body': {'FinServ__Active__c': false}
                }]
            };

            await fetch(tpiurl, {
                headers: {
                    'Content-Type': 'application/json', ...authHeader()
                },
                method: 'POST',
                body: JSON.stringify(JSON.stringify(poaRelationshipCompositeRequest))
            });
        }
        
        // var portfolioBeneficiariesList = formData.filter(x => x["FinServ__FinancialAccount__c-FinServ__FinancialAccountType__c"]);
        // var initialPortfolioBeneficiariesList = initialData.properties.PortfolioBeneficiaries;
        // if (portfolioBeneficiariesList.length > 0) {
        //     portfolioBeneficiariesList.forEach(x => {
        //         updateBeneficiaryPerPortfolio(initialPortfolioBeneficiariesList, x, contactId, FinServ__ReciprocalRole__c);
        //      });
        // }

        const url = `api/t${transactionId !== undefined ? `/${transactionId}` : ''}`;
        const headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': authHeader().Authorization
        });

        const response = await fetch(url, {
            headers,
            method: 'POST',
            body: JSON.stringify(JSON.stringify(sfCompositeRequest))
        })

        let text = await response.json();
        let message = 'success';

        // Since the request is all or none so we only need to check first node http status code
        if (!(text["compositeResponse"][0].httpStatusCode >= 200 && text["compositeResponse"][0].httpStatusCode < 300)) {
            message = 'Saving data back to Salesforce failed, Please contact SFsupport@mawer.com';
            let errorMsg = `AccountId: ${getState().transaction.Account.Id}`;
            text["compositeResponse"].map(response => {
                errorMsg += `Message: ${response.body[0].message}, ErrorCode: ${response.body[0].errorCode}`
            })

            const connectionString = configuration.CONNECTION_STRING;
            const appInsights = new ApplicationInsights({
                config: {
                    connectionString: connectionString
                }
            });
            appInsights.loadAppInsights();
            appInsights.trackException({error: new Error(errorMsg)});
            appInsights.flush();
        }
        
        dispatch({type: SUBMITTING_FORMS, submitting: "submitted", message: message});
    },
    updateVerified: (verified) => (dispatch) => {
        dispatch(actionCreators.updateVerifiedStore(verified));
    },
    setActiveForm: createActionCreator(SET_ACTIVE_FORM, 'activeIndex'),
    updateAccount: createActionCreator(UPDATE_ACCOUNT, 'account'),
    updateContact: createActionCreator(UPDATE_CONTACT, 'contact'),
    updateAwdPac: createActionCreator(UPDATE_AWD_PAC, 'awdPac'),
    updateSpouse: createActionCreator(UPDATE_SPOUSE, 'spouse'),
    updateBeneficiary: createActionCreator(UPDATE_BENEFICIARY, 'beneficiary'),
    updateRma: createActionCreator(UPDATE_RMA, 'rma'),
    updateNrma: createActionCreator(UPDATE_NRMA, 'nrma'),
    updateRnma: createActionCreator(UPDATE_RNMA, 'rnma'),
    updateNrnma: createActionCreator(UPDATE_NRNMA, 'nrnma'),
    updateAac: createActionCreator(UPDATE_AAC, 'aac'),
    updateAae: createActionCreator(UPDATE_AAE, 'aae'),
    updateAafi: createActionCreator(UPDATE_AAFI, 'aafi'),
    updateAaam: createActionCreator(UPDATE_AAAM, 'aaam'),
    updateAacnm: createActionCreator(UPDATE_AACNM, 'aacnm'),
    updateAafinm: createActionCreator(UPDATE_AAFINM, 'aafinm'),
    updateAaenm: createActionCreator(UPDATE_AAENM, 'aaenm'),
    updateAaanm: createActionCreator(UPDATE_AAANM, 'aaanm'),
    updateFixedAssets: createActionCreator(UPDATE_FIXED_ASSETS, 'fixedAssets'),
    updateOtherAssets: createActionCreator(UPDATE_OTHER_ASSETS, 'otherAssets'),
    updateLiabilities: createActionCreator(UPDATE_LIABILITIES, 'liabilities'),
    updateFinancialAccount: createActionCreator(UPDATE_FINANCIAL_ACCOUNT, 'financialAccount'),
    addFinancialAccount: createActionCreator(ADD_FINANCIAL_ACCOUNT, 'financialAccount'),
    addAwdPac: createActionCreator(ADD_AWD_PAC, 'awdPac'),
    addBeneficiary: createActionCreator(ADD_BENEFICIARY, 'beneficiary'),
    updateSpousalContactContactRelation: createActionCreator(UPDATE_SPOUSAL_CONTACT_CONTACT_RELATION, 'spousalContactContactRelation'),
    updateThirdPartyInformation: createActionCreator(UPDATE_THIRD_PARTY_INFORMATION, 'thirdPartyInformation'),
    updateConsentContact: createActionCreator(UPDATE_CONSENT_CONTACT, 'consentContact'),
    updatePoaContact: createActionCreator(UPDATE_POA_CONTACT, 'poaContact'),
    updatePoaAccount: createActionCreator(UPDATE_POA_ACCOUNT, 'poaAccount'),
    updateVerifiedStore: createActionCreator(UPDATE_VERIFIED, 'verified')
};

export const reducer = createReducer(initialState, {
    [SET_FORMS]: (state, action) => ({ ...state, forms: [...action.forms] }),
    [SET_FORM_DATA]: (state, { formId, formData }) => {
        let forms = state.forms.map((form) => {
            if (form.id == formId) {
                form.data = mapFormDataToFormSchema(formData, form.schema)
            }

            return { ...form };
        });
        return { ...state, forms: forms };
    },
    [SET_FINANCIAL_ACCOUNTS]: (state, { financialAccounts }) => {
        const portfolioCodes = [];
        
        financialAccounts.forEach(finAcct => {
            const portfolioData = finAcct.Name + ": " + finAcct.PortfolioCode;
            portfolioCodes.push(portfolioData);
        });

        return ({ ...state, financialAccounts, portfolioCodes });
    },
    [SET_JOINT_FINANCIAL_ACCOUNTS]: (state, { jointFinancialAccounts }) => {
        const jointPortfolioCodes = [];
        
        jointFinancialAccounts.forEach(finAcct => {
            const portfolioData = finAcct.Name + ": " + finAcct.PortfolioCode;
            jointPortfolioCodes.push(portfolioData);
        });

        return ({ ...state, jointFinancialAccounts, jointPortfolioCodes });
    },
    [SET_ACTIVE_FORM]: (state, { activeIndex }) => {
        const syncFormData = (stateToSync, form) => {
            let { Contact, Account, Spouse, AWD_PACs__c, RegisteredMawerAsset, NonRegisteredMawerAsset, RegisteredNonMawerAsset, NonRegisteredNonMawerAsset,
                AssetAllocationCash, AssetAllocationEquity, AssetAllocationFixedIncome, AssetAllocationAlternativeMawer,
                AssetAllocationCashNonMawer, AssetAllocationFixedIncomeNonMawer, AssetAllocationEquityNonMawer, AssetAllocationAlternativeNonMawer,
                FixedAssets, OtherAssets, Liabilities, ThirdPartyInformation, ConsentContact, PoaContact, PoaAccount, Beneficiary__c  } = stateToSync;
            
            var beneficiaryDataToForm = [];
            var beneficiaryForFormData = Beneficiary__c.find(x => {
                return x.id === form.id;
            });
            if(beneficiaryForFormData) {
                beneficiaryDataToForm = beneficiaryForFormData.beneficiaries;
            }
            
            let formDataFromState = {
                ...flattenConcatenateKeys({ Contact: Contact }),
                ...flattenConcatenateKeys({ Account: Account }),
                ...flattenConcatenateKeys({ Spouse: Spouse }),
                ...flattenConcatenateKeys({ RegisteredMawerAsset: RegisteredMawerAsset }),
                ...flattenConcatenateKeys({ NonRegisteredMawerAsset: NonRegisteredMawerAsset }),
                ...flattenConcatenateKeys({ RegisteredNonMawerAsset: RegisteredNonMawerAsset }),
                ...flattenConcatenateKeys({ NonRegisteredNonMawerAsset: NonRegisteredNonMawerAsset }),
                ...flattenConcatenateKeys({ AssetAllocationCash: AssetAllocationCash }),
                ...flattenConcatenateKeys({ AssetAllocationEquity: AssetAllocationEquity }),
                ...flattenConcatenateKeys({ AssetAllocationFixedIncome: AssetAllocationFixedIncome }),
                ...flattenConcatenateKeys({ AssetAllocationAlternativeMawer: AssetAllocationAlternativeMawer }),
                ...flattenConcatenateKeys({ AssetAllocationCashNonMawer: AssetAllocationCashNonMawer }),
                ...flattenConcatenateKeys({ AssetAllocationFixedIncomeNonMawer: AssetAllocationFixedIncomeNonMawer }),
                ...flattenConcatenateKeys({ AssetAllocationEquityNonMawer: AssetAllocationEquityNonMawer }),
                ...flattenConcatenateKeys({ AssetAllocationAlternativeNonMawer: AssetAllocationAlternativeNonMawer }),
                ...flattenConcatenateKeys({ FixedAssets: FixedAssets }),
                ...flattenConcatenateKeys({ OtherAssets: OtherAssets }),
                ...flattenConcatenateKeys({ Liabilities: Liabilities }),
                ...flattenConcatenateKeys({ ThirdPartyInformation: ThirdPartyInformation }),
                ...flattenConcatenateKeys({ ConsentContact: ConsentContact }),
                ...flattenConcatenateKeys({ PoaContact: PoaContact }),
                ...flattenConcatenateKeys({ PoaAccount: PoaAccount }),
                AWD_PACs__c: AWD_PACs__c,
                Beneficiary__c: beneficiaryDataToForm
            }
            let formDataNotForFlatten = {AWD_PACs__c: form.data.AWD_PACs__c, Beneficiary__c: form.data.Beneficiary__c};
            delete form.data.AWD_PACs__c;
            delete form.data.Beneficiary__c;
            let updatedFormData = {};
            var formDataToMerge = {...flatten(form.data), ...formDataNotForFlatten};
            merge(updatedFormData, formDataToMerge, formDataFromState);

            form.data = mapFormDataToFormSchema(updatedFormData, form.schema);
        }

        let forms = state.forms.map((form, index) => {
            let updatedForm = { ...form, active: index === activeIndex };
            
            syncFormData(state, updatedForm);

            return updatedForm;
        })

        return { ...state, forms: forms };
    },
    [UPDATE_ACCOUNT]: (state, { account }) => {
        let updatedAccount = {};
        extend(updatedAccount, state.Account, account);

        return { ...state, Account: updatedAccount }
    },
    [UPDATE_VERIFIED]: (state, { verified }) => {
        return { ...state, verified: verified }
    },
    [UPDATE_RMA]: (state, { rma }) => {
        return { ...state, RegisteredMawerAsset: rma }
    },
    [UPDATE_RNMA]: (state, { rnma }) => {
        return { ...state, RegisteredNonMawerAsset: rnma }
    },
    [UPDATE_NRMA]: (state, { nrma }) => {
        return { ...state, NonRegisteredMawerAsset: nrma }
    },
    [UPDATE_NRNMA]: (state, { nrnma }) => {
        return { ...state, NonRegisteredNonMawerAsset: nrnma }
    },
    [UPDATE_AAC]: (state, { aac }) => {
        return { ...state, AssetAllocationCash: aac }
    },
    [UPDATE_AAE]: (state, { aae }) => {
        return { ...state, AssetAllocationEquity: aae }
    },
    [UPDATE_AAFI]: (state, { aafi }) => {
        return { ...state, AssetAllocationFixedIncome: aafi }
    },
    [UPDATE_AAAM]: (state, { aaam }) => {
        return { ...state, AssetAllocationAlternativeMawer: aaam }
    },
    [UPDATE_AACNM]: (state, { aacnm }) => {
        return { ...state, AssetAllocationCashNonMawer: aacnm }
    },
    [UPDATE_AAFINM]: (state, { aafinm }) => {
        return { ...state, AssetAllocationFixedIncomeNonMawer: aafinm }
    },
    [UPDATE_AAENM]: (state, { aaenm }) => {
        return { ...state, AssetAllocationEquityNonMawer: aaenm }
    },
    [UPDATE_AAANM]: (state, { aaanm }) => {
        return { ...state, AssetAllocationAlternativeNonMawer: aaanm }
    },
    [UPDATE_FIXED_ASSETS]: (state, { fixedAssets }) => {
        return { ...state, FixedAssets: fixedAssets }
    },
    [UPDATE_OTHER_ASSETS]: (state, { otherAssets }) => {
        return { ...state, OtherAssets: otherAssets }
    },
    [UPDATE_LIABILITIES]: (state, { liabilities }) => {
        return { ...state, Liabilities: liabilities }
    },
    [UPDATE_CONTACT]: (state, { contact }) => {
        let updatedContact = {};
        merge(updatedContact, state.Contact, contact);
        if (!isEmpty(contact.Citizenship__c)) {
            updatedContact.Citizenship__c = contact.Citizenship__c;
        }
        
        if (contact.hasOwnProperty("Email") && isEmpty(contact.Email)) {
            updatedContact.Email = null;
        }
        
        return { ...state, Contact: updatedContact }
    },
    [UPDATE_SPOUSE]: (state, { spouse }) => {
        let updatedSpouse = {};
        if (isEmpty(spouse)) {
            return { ...state, Spouse: spouse };
        } else {
            merge(updatedSpouse, state.Spouse, spouse);
            return { ...state, Spouse: updatedSpouse };
        }
    },
    [UPDATE_FINANCIAL_ACCOUNT]: (state, { financialAccount }) => ({
        ...state,
        FinServ__FinancialAccount__c: state.FinServ__FinancialAccount__c.map(originalFinancialAccount => {
            if (financialAccount.Id === originalFinancialAccount.Id) {
                return { ...originalFinancialAccount, ...financialAccount };
            }

            return { ...originalFinancialAccount }
        })
    }),
    [UPDATE_AWD_PAC]: (state, { awdPac }) => ({
        ...state,
        AWD_PACs__c: awdPac
    }),
    [UPDATE_BENEFICIARY]: (state, { beneficiary }) => {
        let currentBeneficiaryState = state.Beneficiary__c.slice(0);
        for(var i=0;i<currentBeneficiaryState.length;i++) {
            if(currentBeneficiaryState[i].id === beneficiary.id) {
                currentBeneficiaryState[i] = beneficiary;
            }
        }
        
        return {...state, Beneficiary__c: currentBeneficiaryState};
    },
    [ADD_FINANCIAL_ACCOUNT]: (state, { financialAccount }) => {
        let FinServ__FinancialAccount__c = state.FinServ__FinancialAccount__c.slice(0);

        FinServ__FinancialAccount__c.push(financialAccount);

        return { ...state, FinServ__FinancialAccount__c };
    },
    [ADD_AWD_PAC]: (state, { awdPac }) => {
        let AWD_PACs__c = state.AWD_PACs__c.slice(0);

        AWD_PACs__c.push(awdPac);
        
        return { ...state, AWD_PACs__c };
    },
    [ADD_BENEFICIARY]: (state, { beneficiary }) => {
        let Beneficiary__c = state.Beneficiary__c.slice(0);

        Beneficiary__c.push(beneficiary);
        
        return { ...state, Beneficiary__c };
    },
    [UPDATE_SPOUSAL_CONTACT_CONTACT_RELATION]: (state, { spousalContactContactRelation }) => {
        return { ...state, SpousalContactContactRelation: spousalContactContactRelation }
    },
    [UPDATE_THIRD_PARTY_INFORMATION]: (state, { thirdPartyInformation }) => {
        let updatedThirdPartyInformation = {};
        merge(updatedThirdPartyInformation, state.ThirdPartyInformation, thirdPartyInformation);
        return { ...state, ThirdPartyInformation: updatedThirdPartyInformation }
    },
    [UPDATE_CONSENT_CONTACT]: (state, { consentContact }) => {
        let updatedConsentContact = {};
        merge(updatedConsentContact, state.ConsentContact, consentContact);
        return { ...state, ConsentContact: updatedConsentContact }
    },
    [UPDATE_POA_CONTACT]: (state, { poaContact }) => {
        let updatedPoaContact = {};
        merge(updatedPoaContact, state.PoaContact, poaContact);
        return { ...state, PoaContact: updatedPoaContact }
    },
    [UPDATE_POA_ACCOUNT]: (state, { poaAccount }) => {
        let updatedPoaAccount = {};
        merge(updatedPoaAccount, state.PoaAccount, poaAccount);
        return { ...state, PoaAccount: updatedPoaAccount };
    },
    [SUBMITTING_FORMS]: (state, { submitting, message }) => {
        return {...state, submitting: submitting, message};
    },
    [SET_NET_WORTH]: (state, { netWorth }) => ({ ...state, netWorth })
})

async function updateBeneficiaryPerPortfolio(initialPortfolioBeneficiariesList, x, contactId, FinServ__ReciprocalRole__c) {
    let portfolioBeneficiaryCompositeRequest = {
        "allOrNone": true,
        "compositeRequest": []
    };
    var originalPortfolioBeneficiary = initialPortfolioBeneficiariesList.find(y => y.FinServ__FinancialAccount__c.sfId === x["FinServ__FinancialAccount__c-Id"]);
    //1. if no beneficiary election is picked, remove all original ones and add a no-election (very bad practice here for original data, however we have to do it)
    if (x["FinServ__FinancialAccount__c-No_Beneficiary_Election"]) {
        if (originalPortfolioBeneficiary && originalPortfolioBeneficiary.Beneficiaries.length > 0) {
            originalPortfolioBeneficiary.Beneficiaries.forEach((z) => {
                let beneficiaryRequest = {
                    "method": "DELETE",
                    "url": "/services/data/v42.0/sobjects/Beneficiary__c/" + z.sfId,
                    "referenceId": "BeneficiaryToDelete-" + z.sfId
                };
                portfolioBeneficiaryCompositeRequest.compositeRequest.push(beneficiaryRequest);
            });
        }
        let noElectionBeneficiaryRequest = {
            "method": "POST",
            "url": "/services/data/v42.0/sobjects/Beneficiary__c/",
            "referenceId": "NoElectionBeneficiary",
            "body": {
                // TODO: remove hard coded no election record Type ID
                "RecordTypeId": recordType.find(a => a.Name === 'No Election' && a.SobjectType === "Beneficiary__c").Id,
                "Financial_Account__c": x["FinServ__FinancialAccount__c-Id"],
                "Allocation_Percentage__c": 100,
                "Name": "No Election",
                "OwnerId": initialData.Account.properties.OwnerId
            }
        };
        portfolioBeneficiaryCompositeRequest.compositeRequest.push(noElectionBeneficiaryRequest);
    }
    else {
        let originalBeneficiaryToBeRemoved;
        if (originalPortfolioBeneficiary && originalPortfolioBeneficiary.Beneficiaries && originalPortfolioBeneficiary.Beneficiaries.length > 0) {
            originalBeneficiaryToBeRemoved = originalPortfolioBeneficiary.Beneficiaries.reduce((acc, curr) => {
                acc.push(curr.sfId);
                return acc;
            }, []);
        }
        //2. 
        x.Beneficiary__c.forEach((currBeneficiary) => {
            if (currBeneficiary.Id) {
                // remove every Id that still exists
                if (originalBeneficiaryToBeRemoved.length > 0) {
                    originalBeneficiaryToBeRemoved.splice(originalBeneficiaryToBeRemoved.indexOf(currBeneficiary.Id), 1);
                }
                // Beneficiary with Contact: Beneficiary/Contingent Beneficiary/Successor Holder/Annuitant (Successor holder/au)
                if (beneficiaryWithContactTypes.includes(currBeneficiary.RecordType)) {
                    // we always assume things changed to simplify logic.
                    let contactChangeRequest;
                    // If Tax_ID__c presents, then we make change with it, if not we skip that field
                    if (currBeneficiary.Contact__c.Tax_ID__c) {
                        contactChangeRequest = {
                            "method": "PATCH",
                            "url": "/services/data/v42.0/sobjects/Contact/" + currBeneficiary.Contact__c.Id,
                            "referenceId": currBeneficiary.Contact__c.Id + currBeneficiary.Id,
                            "body": {
                                "FirstName": currBeneficiary.Contact__c.FirstName,
                                "LastName": currBeneficiary.Contact__c.LastName,
                                "Birthdate": currBeneficiary.Contact__c.Birthdate,
                                "Tax_ID__c": currBeneficiary.Contact__c.Tax_ID__c
                            }
                        };
                    }
                    else {
                        contactChangeRequest = {
                            "method": "PATCH",
                            "url": "/services/data/v42.0/sobjects/Contact/" + currBeneficiary.Contact__c.Id,
                            "referenceId": currBeneficiary.Contact__c.Id + currBeneficiary.Id,
                            "body": {
                                "FirstName": currBeneficiary.Contact__c.FirstName,
                                "LastName": currBeneficiary.Contact__c.LastName,
                                "Birthdate": currBeneficiary.Contact__c.Birthdate
                            }
                        };
                    }
                    portfolioBeneficiaryCompositeRequest.compositeRequest.push(contactChangeRequest);
                    //TODO: Assuming contact contact relationship is always new
                    let beneficiaryContactContactRelationRequest = {
                        "method": "POST",
                        "url": "/services/data/v42.0/sobjects/FinServ__ContactContactRelation__c",
                        "referenceId": "BeneficiaryContactContactRelation" + contactId + currBeneficiary.Contact__c.Id,
                        "body": {
                            "FinServ__Contact__c": contactId,
                            "FinServ__RelatedContact__c": currBeneficiary.Contact__c.Id,
                            "FinServ__Role__c": FinServ__ReciprocalRole__c[currBeneficiary.Relationship__c],
                            "OwnerId": initialData.Account.properties.OwnerId
                        }
                    };
                    portfolioBeneficiaryCompositeRequest.compositeRequest.push(beneficiaryContactContactRelationRequest);
                    let beneficiaryRequest = {
                        "method": "PATCH",
                        "url": "/services/data/v42.0/sobjects/Beneficiary__c/" + currBeneficiary.Id,
                        "referenceId": "Beneficiary" + currBeneficiary.Id,
                        "body": {
                            "Contact__c": currBeneficiary.Contact__c.Id,
                            "Allocation_Percentage__c": currBeneficiary.Allocation_Percentage__c,
                            "Relationship__c": currBeneficiary.Relationship__c,
                            // Hard code to contact when a beneficiary is related to a contact for the moment
                            "Name": "Contact",
                            "RecordTypeId": recordType.find(a => a.Name === currBeneficiary.RecordType && a.SobjectType === "Beneficiary__c").Id
                        }
                    };
                    portfolioBeneficiaryCompositeRequest.compositeRequest.push(beneficiaryRequest);
                }
                // Else, it will be estate/charity
                else if (beneficiaryWithoutContactTypes.includes(currBeneficiary.RecordType)) {
                    let beneficiaryRequest = {
                        "method": "PATCH",
                        "url": "/services/data/v42.0/sobjects/Beneficiary__c/" + currBeneficiary.Id,
                        "referenceId": "Beneficiary" + currBeneficiary.Id,
                        "body": {
                            "Allocation_Percentage__c": currBeneficiary.Allocation_Percentage__c,
                            // Hard code to contact when a beneficiary is related to a contact for the moment
                            "Name": currBeneficiary.Name ? currBeneficiary.Name : currBeneficiary.RecordType,
                            "RecordTypeId": recordType.find(a => a.Name === currBeneficiary.RecordType && a.SobjectType === "Beneficiary__c").Id
                        }
                    };
                    portfolioBeneficiaryCompositeRequest.compositeRequest.push(beneficiaryRequest);
                }
                else {
                    console.log("it should never come here since the record type is having issues! Thus we are not saving anything!");
                }
            }
            else {
                if (beneficiaryWithContactTypes.includes(currBeneficiary.RecordType)) {
                    let contactChangeRequest;
                    // If Tax_ID__c presents, then we make change with it, if not we skip that field
                    if (currBeneficiary.Contact__c.Tax_ID__c) {
                        contactChangeRequest = {
                            "method": "PATCH",
                            "url": "/services/data/v42.0/sobjects/Contact/" + currBeneficiary.Contact__c.Id,
                            "referenceId": currBeneficiary.Contact__c.Id + 'PatchTaxId',
                            "body": {
                                "FirstName": currBeneficiary.Contact__c.FirstName,
                                "LastName": currBeneficiary.Contact__c.LastName,
                                "Birthdate": currBeneficiary.Contact__c.Birthdate,
                                "Tax_ID__c": currBeneficiary.Contact__c.Tax_ID__c
                            }
                        };
                    }
                    else {
                        contactChangeRequest = {
                            "method": "PATCH",
                            "url": "/services/data/v42.0/sobjects/Contact/" + currBeneficiary.Contact__c.Id,
                            "referenceId": currBeneficiary.Contact__c.Id + 'PatchContact',
                            "body": {
                                "FirstName": currBeneficiary.Contact__c.FirstName,
                                "LastName": currBeneficiary.Contact__c.LastName,
                                "Birthdate": currBeneficiary.Contact__c.Birthdate
                            }
                        };
                    }
                    portfolioBeneficiaryCompositeRequest.compositeRequest.push(contactChangeRequest);
                    //TODO: Assuming contact contact relationship is always new
                    let beneficiaryContactContactRelationRequest = {
                        "method": "POST",
                        "url": "/services/data/v42.0/sobjects/FinServ__ContactContactRelation__c",
                        "referenceId": "BeneficiaryContactContactRelation" + contactId + currBeneficiary.Contact__c.Id,
                        "body": {
                            "FinServ__Contact__c": contactId,
                            "FinServ__RelatedContact__c": currBeneficiary.Contact__c.Id,
                            "FinServ__Role__c": FinServ__ReciprocalRole__c[currBeneficiary.Relationship__c],
                            "OwnerId": initialData.Account.properties.OwnerId
                        }
                    };
                    portfolioBeneficiaryCompositeRequest.compositeRequest.push(beneficiaryContactContactRelationRequest);
                    let beneficiaryRequest = {
                        "method": "POST",
                        "url": "/services/data/v42.0/sobjects/Beneficiary__c",
                        "referenceId": "NewBeneficiary" + currBeneficiary.RecordType + currBeneficiary.Contact__c.Id,
                        "body": {
                            "Contact__c": currBeneficiary.Contact__c.Id,
                            "Allocation_Percentage__c": currBeneficiary.Allocation_Percentage__c,
                            "Relationship__c": currBeneficiary.Relationship__c,
                            "Financial_Account__c": x["FinServ__FinancialAccount__c-Id"],
                            // Hard code to contact when a beneficiary is related to a contact for the moment
                            "Name": "Contact",
                            "RecordTypeId": recordType.find(a => a.Name === currBeneficiary.RecordType && a.SobjectType === "Beneficiary__c").Id,
                            "OwnerId": initialData.Account.properties.OwnerId
                        }
                    };
                    portfolioBeneficiaryCompositeRequest.compositeRequest.push(beneficiaryRequest);
                }
                // Else, it will be estate/charity
                else if (beneficiaryWithoutContactTypes.includes(currBeneficiary.RecordType)) {
                    let beneficiaryRequest = {
                        "method": "POST",
                        "url": "/services/data/v42.0/sobjects/Beneficiary__c",
                        "referenceId": "NewBeneficiary" + currBeneficiary.RecordType + (currBeneficiary.Name ? currBeneficiary.Name : ""),
                        "body": {
                            "Allocation_Percentage__c": currBeneficiary.Allocation_Percentage__c,
                            // Hard code to contact when a beneficiary is related to a contact for the moment
                            "Name": currBeneficiary.Name ? currBeneficiary.Name : currBeneficiary.RecordType,
                            "Financial_Account__c": x["FinServ__FinancialAccount__c-Id"],
                            "RecordTypeId": recordType.find(a => a.Name === currBeneficiary.RecordType && a.SobjectType === "Beneficiary__c").Id,
                            "OwnerId": initialData.Account.properties.OwnerId
                        }
                    };
                    portfolioBeneficiaryCompositeRequest.compositeRequest.push(beneficiaryRequest);
                }
                else {
                    console.log("it should never come here since the record type is having issues! Thus we are not saving anything!");
                }
            }
        });
        if (originalBeneficiaryToBeRemoved && originalBeneficiaryToBeRemoved.length > 0) {
            originalBeneficiaryToBeRemoved.forEach((beneficiaryId) => {
                let beneficiaryRequest = {
                    "method": "DELETE",
                    "url": "/services/data/v42.0/sobjects/Beneficiary__c/" + beneficiaryId,
                    "referenceId": "BeneficiaryToDelete-" + beneficiaryId
                };
                portfolioBeneficiaryCompositeRequest.compositeRequest.push(beneficiaryRequest);
            });
        }
    }
    const tpiurl = `api/t/${initialData.sfId}`;
    await fetch(tpiurl, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': authHeader().Authorization
        },
        method: 'POST',
        body: JSON.stringify(JSON.stringify(portfolioBeneficiaryCompositeRequest))
    })
        .then(resp => resp.json())
        .then(respJson => {
            console.log(respJson);
        });
}

async function updatePoaContact(PoaContact, contactId, FinServ__ReciprocalRole__c, transactionId) {
    let poaContactCompositeRequest = {
        "allOrNone": true,
        "compositeRequest": []
    };
    let poaContactRequest;
    let relationshipMissing = false;

    //check if contact already exists to avoid duplicates
    if(!PoaContact.Id) {
        const existingPoaCompositeRequest = {
            "allOrNone": true,
            "compositeRequest": [{
                'method': 'GET',
                'url': `/services/data/v42.0/query/?q=SELECT+Id+FROM+Contact+WHERE+FirstName='${PoaContact.FirstName}'+AND+LastName='${PoaContact.LastName}'`,
                'referenceId': 'existingPoa'
            }]
        };
        const tpiurl = `api/t${transactionId !== undefined ? `/${transactionId}` : ''}`;
        await fetch(tpiurl, {
            headers: {
                'Content-Type': 'application/json', ...authHeader()
            },
            method: 'POST',
            body: JSON.stringify(JSON.stringify(existingPoaCompositeRequest))
        }).then(response => response.json()).then(respJson => {
            PoaContact.Id = respJson?.compositeResponse[0]?.body?.records[0]?.Id
            relationshipMissing = true;
        });
    }
    
    if (PoaContact.Id) {
        poaContactRequest = {
            "method": "PATCH",
            "url": "/services/data/v42.0/sobjects/Contact/" + PoaContact.Id,
            "referenceId": "PoaContact",
            "body": {
                "FirstName": PoaContact.FirstName,
                "LastName": PoaContact.LastName,
                "Email": PoaContact.Email,
                "Birthdate": PoaContact.Birthdate,
                "Phone": PoaContact.Phone,
                "FinServ__Occupation__c": PoaContact.FinServ__Occupation__c,
                "FinServ__CurrentEmployer__c": PoaContact.FinServ__CurrentEmployer__c,
                "Employer_Address__c": PoaContact.Employer_Address__c,
                "Insider__c": PoaContact.Insider__c,
                "If_YES_to_Insider_list_company_name__c": PoaContact.If_YES_to_Insider_list_company_name__c,
                "Politically_Exposed__c": PoaContact.Politically_Exposed__c
            }
        };
    } else {
        poaContactRequest = {
            "method": "POST",
            "url": "/services/data/v42.0/sobjects/Contact/",
            "referenceId": "PoaContact",
            "body": {
                "OwnerId": initialData.Account.properties.OwnerId,
                "RecordTypeId": recordType.find(a => a.Name === 'Individual' && a.SobjectType === "Contact").Id,
                "FirstName": PoaContact.FirstName,
                "LastName": PoaContact.LastName,
                "Email": PoaContact.Email,
                "Birthdate": PoaContact.Birthdate,
                "Phone": PoaContact.Phone,
                "FinServ__Occupation__c": PoaContact.FinServ__Occupation__c,
                "FinServ__CurrentEmployer__c": PoaContact.FinServ__CurrentEmployer__c,
                "Employer_Address__c": PoaContact.Employer_Address__c,
                "Insider__c": PoaContact.Insider__c,
                "If_YES_to_Insider_list_company_name__c": PoaContact.If_YES_to_Insider_list_company_name__c,
                "Politically_Exposed__c": PoaContact.Politically_Exposed__c
            }
        };
    }
    
    poaContactCompositeRequest.compositeRequest.push(poaContactRequest);

    if (!PoaContact.Id || relationshipMissing) {
        let poaContactContactRelationRequest = {
            "method": "POST",
            "url": "/services/data/v42.0/sobjects/FinServ__ContactContactRelation__c",
            "referenceId": "PoaContactContactRelation",
            "body": {
                "FinServ__Contact__c": contactId,
                "FinServ__RelatedContact__c": PoaContact.Id ? PoaContact.Id : "@{PoaContact.id}",
                "FinServ__Role__c": FinServ__ReciprocalRole__c["Power of Attorney"],
                "OwnerId": initialData.Account.properties.OwnerId
            }
        };
        poaContactCompositeRequest.compositeRequest.push(poaContactContactRelationRequest);
    }

    if (poaContactCompositeRequest.compositeRequest.length > 0) {
        const tpiurl = `api/t${transactionId !== undefined ? `/${transactionId}` : ''}`;
        await fetch(tpiurl, {
            headers: {
                'Content-Type': 'application/json', ...authHeader()
            },
            method: 'POST',
            body: JSON.stringify(JSON.stringify(poaContactCompositeRequest))
        }).then(response => response.json()).then(respJson => {
            if (!PoaContact.Id) {
                PoaContact.Id = respJson?.compositeResponse[0]?.body?.id;
            }
        });;
    }
}
async function updatePoaAccount(PoaAccount, PoaContact, transactionId) {
    let poaAccountCompositeRequest = {
        "allOrNone": true,
        "compositeRequest": []
    };
    let poaAccountRequest;

    if(!PoaAccount.Id) {
        const existingPoaCompositeRequest = {
            "allOrNone": true,
            "compositeRequest": [{
                'method': 'GET',
                'url': `/services/data/v42.0/query/?q=SELECT+Id,AccountId+FROM+Contact+WHERE+Id='${PoaContact.Id}'`,
                'referenceId': 'existingPoa'
            }]
        };
        const tpiurl = `api/t${transactionId !== undefined ? `/${transactionId}` : ''}`;
        await fetch(tpiurl, {
            headers: {
                'Content-Type': 'application/json', ...authHeader()
            },
            method: 'POST',
            body: JSON.stringify(JSON.stringify(existingPoaCompositeRequest))
        }).then(response => response.json()).then(respJson => {
            PoaAccount.Id = respJson?.compositeResponse[0]?.body?.records[0]?.AccountId
        });
    }
    
    poaAccountRequest = {
        "method": "PATCH",
        "url": "/services/data/v42.0/sobjects/Account/" + PoaAccount.Id,
        "referenceId": "PoaAccount",
        "body": {
            "BillingStreet": PoaAccount.BillingStreet,
            "BillingCity": PoaAccount.BillingCity,
            "BillingState": PoaAccount.BillingState,
            "BillingPostalCode": PoaAccount.BillingPostalCode,
            "BillingCountry": PoaAccount.BillingCountry
        }
    };
    
    poaAccountCompositeRequest.compositeRequest.push(poaAccountRequest);

    if (poaAccountCompositeRequest.compositeRequest.length > 0) {
        const tpiurl = `api/t${transactionId !== undefined ? `/${transactionId}` : ''}`;
        await fetch(tpiurl, {
            headers: {
                'Content-Type': 'application/json', ...authHeader()
            },
            method: 'POST',
            body: JSON.stringify(JSON.stringify(poaAccountCompositeRequest))
        });
    }
}
async function updateConsentToShareInfoContact(ConsentContact, contactId, FinServ__ReciprocalRole__c, transactionId) {
    let consentContactCompositeRequest = {
        "allOrNone": true,
        "compositeRequest": []
    };
    let consentContactRequest = {
        "method": "POST",
        "url": "/services/data/v42.0/sobjects/Contact/",
        "referenceId": "ConsentContact",
        "body": {
            "RecordTypeId": recordType.find(a => a.Name === 'Individual' && a.SobjectType === "Contact").Id,
            "FirstName": ConsentContact.FirstName,
            "LastName": ConsentContact.LastName,
            "Email": ConsentContact.Email,
            "MailingStreet": ConsentContact.MailingStreet,
            "MailingCity": ConsentContact.MailingCity,
            "MailingPostalCode": ConsentContact.MailingPostalCode,
            "MailingCountry": ConsentContact.MailingCountry,
            "OwnerId": initialData.Account.properties.OwnerId
        }
    };
    consentContactCompositeRequest.compositeRequest.push(consentContactRequest);
    let consentContactContactRelationRequest = {
        "method": "POST",
        "url": "/services/data/v42.0/sobjects/FinServ__ContactContactRelation__c",
        "referenceId": "ConsentContactContactRelation",
        "body": {
            "FinServ__Contact__c": contactId,
            "FinServ__RelatedContact__c": "@{ConsentContact.id}",
            "FinServ__Role__c": FinServ__ReciprocalRole__c[ConsentContact.Relationship],
            "OwnerId": initialData.Account.properties.OwnerId
        }
    };
    consentContactCompositeRequest.compositeRequest.push(consentContactContactRelationRequest);
    var portfolios = initialData.properties.Portfolios;
    var hasWebAccess = ConsentContact.OnlineAccess;
    var receivesStatement = ConsentContact.QuarterlyReporting;
    // TODO: pending the other three checkbox on line
    for (var i = 0; i < portfolios.length; i++) {
        var financialAccount = portfolios[i];
        var consentFinancialAccountRoleRequest = {
            "method": "POST",
            "url": "/services/data/v42.0/sobjects/FinServ__FinancialAccountRole__c",
            "referenceId": "ConsentContactFinancialAccountRole_" + i.toString(),
            "body": {
                "RecordTypeId": recordType.find(a => a.Name === 'Contact Role' && a.SobjectType === "FinServ__FinancialAccountRole__c").Id,
                "FinServ__RelatedContact__c": "@{ConsentContact.id}",
                "FinServ__FinancialAccount__c": financialAccount.Id,
                "FinServ__Role__c": "Reporting Contact",
                "Has_Web_Access__c": hasWebAccess,
                "Receives_Statement_Copy__c": receivesStatement
            }
        };
        consentContactCompositeRequest.compositeRequest.push(consentFinancialAccountRoleRequest);
    }
    if (consentContactCompositeRequest.compositeRequest.length > 0) {
        const tpiurl = `api/t${transactionId !== undefined ? `/${transactionId}` : ''}`;
        const consentContactCompositeResp = await fetch(tpiurl, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authHeader().Authorization
            },
            method: 'POST',
            body: JSON.stringify(JSON.stringify(consentContactCompositeRequest))
        });
        let consentContactCompositeRespText = await consentContactCompositeResp.json();
        console.log(consentContactCompositeRespText);
    }
}

